import "core-js/modules/es6.object.keys.js";
export default function splitObject(obj, parts) {
  var left = {};
  var right = {};
  Object.keys(obj).forEach(function (k) {
    if (parts.indexOf(k) !== -1) {
      left[k] = obj[k];
    } else {
      right[k] = obj[k];
    }
  });
  return [left, right];
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-timeline/src/splitObject.js